const state = {
  open: false
}

const getters = {
  open: state => state.open
}

const actions = {
  toggleBar({ commit }) {
    commit('toggleBar')
  }
}

const mutations = {
  toggleBar(state) {
    state.open = !state.open
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}